import { createI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { usePersonalStore } from '../stores/personal'
import en from '@/translations/xprotargeting_en.json'
import ja from '@/translations/xprotargeting_ja.json'

const locale = navigator.language.split('-')[0]

export const i18n = createI18n({
  legacy: false,
  allowComposition: true,
  locale,
  fallbackLocale: 'en',
  messages: { en, ja },
  datetimeFormats: {
    en: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
    },
    ja: {
      short: {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      },
    },
  },
})

export function setLocale(newLocale: 'en' | 'ja') {
  const personalStore = usePersonalStore()
  const { locale: localeStore } = storeToRefs(personalStore)
  const { locale } = i18n.global

  locale.value = newLocale
  localeStore.value = newLocale
}

export function isJapanese() {
  return i18n.global.locale.value === 'ja'
}
